/* istanbul ignore file */
export * from './CmsTopBanner';
